import styled from "styled-components";
import { useNavigate } from 'react-router-dom';
import {
    Card,
    Typography,
} from "@mui/material";

import { IconCircleCheckFilled, IconChevronLeft } from '@tabler/icons-react';

import { GeneratedLicenseKeyInterface } from '../../../Models/Common/CustomViewsInterfaces';

import { ButtonType } from '../../../Utilities/Enums/ButtonTypeEnum';
import { RouteEnum } from '../../../Utilities/Enums/RouteEnums';

import CustomButton from '../../Elements/CustomButton';

const GeneratedLicenseKeyContainer: any = styled(Card)<{ }>`
    background: transparent !important;
    border: none;
    border-radius: 0px !important;
    box-shadow: none !important;
    width: 500px;
    display: grid;
    grid-template-columns: 1fr;
    place-items: center;
    align-items: center;
    padding: 10px;
    justify-self: center;

    .headersvg {
        width: 80px;
        height: 80px;
        margin: 0px 0px 40px 0px;
    }
    
    .headerTitle {
        font-size: 1.09375rem !important;
        font-weight: 600;
    }

    .headerSubtitle {
        font-size: 0.825rem !important;
        font-weight: 500;
        color: #878a99;
    }

    .goToLicensePageBtn {
        margin: 40px 0px;
    }
`;

const ItemContainer: any = styled(Card)<{ }>`
    background: transparent !important;
    border: none;
    border-radius: 0px !important;
    box-shadow: none !important;
    width: 100%;
    display: flex;
    justify-content: center;
    margin: 20px 0px 0px 0px;

    .itemTitle, .itemValue {
        font-size: 1.09375rem;
        font-weight: 600 !important
    }

    .itemValue {
        margin: 0px 0px 0px 5px;
        color: #f06548 !important;
    }

    .invoiceNo {
        color: #25a0e2 !important;
        text-decoration: underline;
        cursor: pointer;
    }

    .licenseKey {
        cursor: pointer;
    }
`;

const GeneratedLicenseKey = (props: GeneratedLicenseKeyInterface) => {
    const navigate = useNavigate();

    return <GeneratedLicenseKeyContainer>
        <IconCircleCheckFilled className="headersvg" color='var(--hrDashboardIconColor)'/>
        <Typography className="headerTitle" color='primaryText'>{props?.headerTitle ?? "--"}</Typography>
        <Typography className="headerSubtitle">{props?.headerSubTitle ?? "--"}</Typography>

        {props?.invoiceNo && <ItemContainer>
            <Typography className="itemTitle" color='primaryText'>Invoice No.:</Typography>
            <Typography className="itemValue invoiceNo" onClick={() => {
                if(props?.onclickInvoiceNo) {
                    props.onclickInvoiceNo();
                }
            }} >
                {props?.invoiceNo ?? "--"}
            </Typography>
        </ItemContainer>}

        {props?.licenseKey && <ItemContainer>
            <Typography className="itemTitle" color='primaryText'>License Key:</Typography>
            <Typography className="itemValue licenseKey" onClick={() => {
                if(props?.onclickLicenseKey) {
                    props.onclickLicenseKey();
                }
            }} >
                {props?.licenseKey ?? "--"}
            </Typography>
        </ItemContainer>}

        {!props?.hideLicensePageButton &&
            <CustomButton
                className="goToLicensePageBtn"
                btnType={ButtonType.PRIMARY_LIGHT}
                title='Back to License Page'
                startIcon={<IconChevronLeft />}
                // isRoundedCorner={true}
                onClick={(e: any) => {
                    navigate(`${RouteEnum.LICENSES}`, { replace: true });
                }} />
        }
    </GeneratedLicenseKeyContainer>
}

export default GeneratedLicenseKey;